module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/copy-e41b08294a602c11c3c266818149ab98.svg";